import { css } from 'linaria';

export const componentContainer = css`
  display: block;
  width: 180px;
  padding: 0;
`;
export const componentContainerThin = css`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  width: 288px;

  width: 100%;
  padding: 14px 20px;

  background-color: var(--background-primary, #ffffff);
  border: 1px solid #e1e2e5;
  border-radius: 8px;
`;

export const logoImageContainer = css`
  display: flex;
  flex-direction: row;
  justify-content: start;

  flex-grow: 0;
  flex-shrink: 0;
  width: 130px;
  height: 60px;
`;

export const vendorLogoImg = css`
  width: 130px;
  height: 60px;
`;

export const titleContainer = css`
  padding-top: 12px;
`;

export const titleContainerThin = css`
  flex-grow: 1;
  flex-shrink: 1;
  padding-top: 0;
  padding-right: 12px;
`;

export const titleContent = css`
  width: 100%;
  overflow: hidden;
`;
